export { enUS } from "./en-US";
export { zhCN } from "./zh-CN";
export type { Translations } from "./types";
